import type { TOptions } from "i18next";

export function getPostProcessorResolvedLocale(
  options: TOptions
): string | undefined {
  return options.i18nResolved?.usedLng;
}

export function getPostProcessorResolvedNamespace(
  options: TOptions
): string | undefined {
  return options.i18nResolved?.usedNS;
}

export function getPostProcessorResolvedKey(
  options: TOptions,
  fallbackKey: string | string[]
): string | undefined {
  const exactUsedKey = options.i18nResolved?.exactUsedKey;
  if (typeof exactUsedKey === "string" && exactUsedKey.length > 0) {
    return exactUsedKey;
  }

  const key = Array.isArray(fallbackKey) ? fallbackKey[0] : fallbackKey;
  return typeof key === "string" ? key : undefined;
}
